import React, { useState } from 'react'
import { SidebarButton, SidebarSection, SidebarSectionTitle } from '../style'
import { Paperclip, User, Clock, CheckSquare, Tag } from 'lucide-react'
import MiniScreenForSelects from '../../../MiniScreenForSelects'
import { OpViewerType } from '..'

interface PropsType {
  op: OpViewerType
}

const Actions:React.FC<PropsType> = ({op}) => {
  const [ viewMiniMenu, setViewMiniMenu ] = useState<boolean>(true)
  
  return (
    <SidebarSection style={{marginTop: '2rem'}}>
      <ul style={{listStyle: 'none'}}>
        <li>
          <SidebarSectionTitle>Ações</SidebarSectionTitle>
          <SidebarButton>
            <User size={14} /> Próxima etapa
          </SidebarButton>
          {viewMiniMenu && <MiniScreenForSelects op={op} />}
        </li>
      </ul>
    </SidebarSection>
  )
}

export default Actions